import React from 'react';
import {
  DSGlobalHeader,
  type DSGlobalHeaderInternalsT,
} from '@elliemae/ds-global-header';
import { Grid } from '@elliemae/ds-grid';
import { ENCDarkIceBlue, ENCIceBlue } from '@elliemae/ds-icons';

const breadcrumb: DSGlobalHeaderInternalsT.BreadcrumbItem[] = [
  { label: 'ICE PPE', hasNext: false },
];

// Encompass | ICE PPE bar for the standalone dashboard, which has no host app chrome.
export const DashboardGlobalHeader: React.FC = () => (
  <Grid minWidth="570px">
    <DSGlobalHeader
      Logo={ENCIceBlue}
      LogoWithBrand={ENCDarkIceBlue}
      breadcrumb={breadcrumb}
      toolbar={[]}
    />
  </Grid>
);

export default DashboardGlobalHeader;
